export default __webpack_public_path__ + "static/media/service-thumb-concrete-curb.8a7073f1.jpg";